<template>
    <span class="sby-signing">
        <van-button
            :class="(item.state != 'renew' ? 'order-action' :'renew-action'  ) + ' margin-right-10'"
            @click="showConfirm()"
            :disabled="item.state != 'renew' "
            v-if="item.state != 'renewed'"
            size="small"
        >到期续签</van-button>
        <van-dialog v-model="show" title="到期续签"  getContainer=".page-wrap" class="sby-signing-dialog" show-cancel-button @confirm="submitSigning()">
            <div>根据当前缴纳信息自动顺延，请选择是否使用优惠券或者变更代缴信息：</div>
            <van-radio-group v-model="siginType">
                <van-radio name="withoutChange">不变更，直接顺延</van-radio>
                <van-radio name="goChange">使用优惠券/变更缴纳信息后顺延</van-radio>
            </van-radio-group>
        </van-dialog>
    </span>
</template>


<script>
import _ from "lodash";
import { SlotsMixin } from "../pages/util/slots";
import moment from "moment";
import { RadioGroup, Radio } from "vant";
import Vue from "vue";

Vue.use(RadioGroup);
Vue.use(Radio);

import {
  Toast,
  Dialog,
  Icon,
  Row,
  Checkbox,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  Button,
  Popup,
  Notify,
  Uploader,
  Field
} from "vant";

Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Row);
Vue.use(Button).use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Collapse);
Vue.use(Field).use(Notify);
Vue.use(CollapseItem).use(Uploader);

export default {
  name: "sby-signing-btn",
  mixins: [SlotsMixin],
  props: {
    item: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    },

  },
  data() {
    return {
      show: false,
      order:{},
      siginType: "withoutChange"
    };
  },
  computed: {},
  mounted() {
    this.order = this.item;
  },
  methods: {
    showConfirm(){
      if (this.order.payment_term === 'custom') {
        this.siginType = 'goChange';
        this.order.payment_term = 'month';
        this.submitSigning() ;
      } else {
        this.show = true;
      }
    },
    showSlots(name) {
      const { slots, labelAlign } = this;

      return slots(name);
    },
    submitSigning() {
      let payment_items = [];
      for (let item of this.order.lastBill.payment_items) {
        if (this.order['item_' + item].status !== 'finished') {
          payment_items.push(item);
        }
      }
      if (payment_items.length === 0) {
        miniToastr.info( '续签失败，无待续签项目');
        return;
      }
      
      let orderInfo = {
        profile: {
          id: this.order.profileid,
          census_type: this.order.census_type
        },
        payment_items: payment_items,
        payment_way: this.order.payment_way,
        payment_term: this.order.payment_term,
        locations: this.order.locations,
        payment_date_start: moment(this.order.payment_date_end)
          .add(1, "month")
          .format("YYYY-MM-DD"),
      };
      if (payment_items.includes('salary')) {
        orderInfo = _.extend({}, orderInfo, {
          ...this.order.lastBill.item_salary
        });
      }
      if (payment_items.includes('shebao')) {
        orderInfo = _.extend({}, orderInfo, {
          ...this.order.lastBill.item_shebao
        });
      }
      if (payment_items.includes('gongjijin')) {
        orderInfo = _.extend({}, orderInfo, {
          ...this.order.lastBill.item_gongjijin
        });
      }
      if (payment_items.includes('ztax')) {
        orderInfo = _.extend({}, orderInfo, {
          ...this.order.lastBill.item_ztax
        });
      }
      if (payment_items.includes('tax')) {
        orderInfo = _.extend({}, orderInfo, {
          ...this.order.lastBill.item_tax
        });
      }
      if (this.siginType === "withoutChange") {
        this.$http
        .post("/api/order/new", orderInfo )
        .then(response => {
          if (response) {
            let data = response.data.data;
            Toast.success("续签成功，请尽快付款");
            this.$router.replace({ name: "order-detail", params: { orderno: data.orderno } });
            this.$store.commit("stashOrder", {}, false);
          }
        })
        .catch(err => {});
      } else {
        this.$store.commit("saveOrder", orderInfo);
        this.$router.push("/order/create/confirm");
      }
    }
  },
  watch: {},
  beforeDestroy() {
    //Notify.clear();
  }
};
</script>
<style lang="less" >
.renew-action {
  margin-right: 8px;
  line-height: 22px;
  font-size: 10px;
  color: white;
  border-radius: 22px;
  -webkit-transform-origin: left top;
  transform-origin: left top;
  height: 22px;
  border: none;
  background-color: #06bf04;
}

</style>


// WEBPACK FOOTER //
// src/components/sby-signing-btn.vue